import { api } from "@monolith/helpers";
import { dayRange } from "@monolith/helpers";

class Reports {
  // times by 100 for no rounding errors
  // loop at intl api

  currencyFormat(amount) {
    let correctAmount = new Intl.NumberFormat("en-NZ", { style: "currency", currency: "NZD" }).format(amount);
    return correctAmount;
  }

  weekDayLabels() {
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    return days;
  }

  monthLabels() {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return months;
  }

  getMonthsWithinRange(start, end) {
    let months = [];
    let dates = [];
    let startMonth = start.substring(5, 7);
    let endMonth = end.substring(5, 7);
    // look into this - what about when changes year?
    let year = start.substring(0, 4);

    // loop through how many months
    for (let i = startMonth; i <= endMonth; i++) {
      startMonth = i;
      let newDate = year + "-" + startMonth;
      let date = new Date(newDate);
      let monthName = new Date(newDate).toLocaleString("default", { month: "long" });
      months.push(monthName);
      dates.push(date);
    }

    return [months, dates];
  }

  dayRangeLabels(dates) {
    const dayNumbers = dates.map((d) => d.getDate());
    return dayNumbers;
  }

  utcFix(date) {
    const hour = parseInt(date.slice(11, 13));
    const day = date.slice(0, 10);
    const timezoneOffset = new Date(day).getTimezoneOffset() / 60;
    return (hour - timezoneOffset) % 24;
  }

  fixDateQuery(unix) {
    return new Date(unix).toISOString().slice(0, 13);
  }

  formatFromDate(date) {
    // date should come through as date object
    // return as YYYY-MM-DD
    return date.toLocaleString().substring(0, 10).split("/").reverse().join("-");
  }

  getTimeZoneOffset() {
    let date = new Date();
    let timezoneOffset = date.getTimezoneOffset() / -60;
    return timezoneOffset;
  }

  getMonthString(date) {
    let dateObj = new Date(date);
    return dateObj.toLocaleString("default", { month: "long" });
  }

  shiftHours(date, shift) {
    const newDate = new Date(date);
    newDate.setHours(newDate.getHours() + shift);
    return newDate;
  }

  getISOWeekString(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const day = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - day);

    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const week = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

    return `${d.getUTCFullYear()}-W${String(week).padStart(2, "0")}`;
  }

  // get the sales and count data over an array of days
  async fetchTimeFrameData(days, dataType, company, site) {
    if (dataType == "sales") {
      return await api.get_sales_timeframe(site, days);
    } else {
      return await api.get_count_timeframe(site, days);
    }
  }

  async fetchTotals(start, end, dataType, company, site) {
    if (dataType == "sales") {
      return await api.get_sales_total(site, start, end);
    } else {
      return await api.get_count_total(site, start, end);
    }
  }

  async fetchRawData(start, end, dataType, company, site) {
    if (dataType == "sales") {
      return await api.get_sales_data(site, start, end);
    } else {
      return await api.get_product_count(site, start, end);
    }
  }

  async fetchRawStackedData(start, end, dataType, company, site) {
    if (dataType == "sales") {
      return await api.get_stacked_data(site, start, end);
    } else {
      return await api.get_stacked_count(site, start, end);
    }
  }

  async fetchRawStackedProductData(start, end, dataType, company, site) {
    if (dataType == "sales") {
      return await api.get_products_stacked_data(site, start, end);
    } else {
      return await api.get_products_stacked_count(site, start, end);
    }
  }

  async getTotals(start, end, dataType, company, site) {
    if (dataType == "sales") {
      return await api.get_sales_total(site, start, end);
    } else {
      return await api.get_count_total(site, start, end);
    }
  }

  async getData(start, end, dataType, company, site) {
    if (dataType == "sales") {
      return await api.get_sales_data(site, start, end);
    } else {
      return await api.get_product_count(site, start, end);
    }
  }

  // check if there is a count one 
  async getPaymentData(start, end, company, site) {
    return await api.get_sales_payment_data(start, end, site);
  }

  // from the day range in local time, fix to be utc ok
  fixDateRangeUTC(sale) {
    // this is incorrect!!!!!
    // for each sale split the date to create a new object
    const year = sale.slice(0, 4);
    const month = sale.slice(5, 7);
    const day = sale.slice(8, 10);
    const hours = parseInt(sale.slice(11, 13) || "0", 10) || 0;
    const date = new Date(year, month - 1, day, hours);

    // find how many hours you should move the date for timezone
    const hourMove = this.utcFix(date.toLocaleString().substring(0, 10).split("/").reverse().join("-") + "T" + hours + ":00:00");

    // edit the hour based on timezone fix and fix format
    const fixedDate = dayRange.editHour(-hourMove, date);
    fixedDate.toLocaleString().substring(0, 10).split("/").reverse().join("-");

    // return with the utc fixed date
    return fixedDate;
  }

  // get the week dates from the week number
  getWeekDates(week) {
    // week comes through as 2025-W44
    // find the start of the week
    let startDateOfWeek = dayRange.getDateOfWeek(week.substring(6, 8), week.substring(0, 4));
    let allDates = [];

    // loop for 7 days
    for (let i = 0; i <= 6; i++) {
      // move the day through each step of the week
      let adjustedDates = dayRange.editDay(i, startDateOfWeek);

      // put the 7 days into an array
      allDates.push(adjustedDates);
    }

    // return the 7 dates values in an array
    return allDates;
  }

  // get all the dates in the months array
  allDatesInMonth(months) {
    const allDays = [];
    const dateRanges = [];

    months.forEach((monthStart) => {
      const year = monthStart.getFullYear();
      const month = monthStart.getMonth();
      let d = new Date(year, month, 1); // always midnight local??

      // Loop until we leave the month
      while (d.getMonth() === month) {
        allDays.push(new Date(d)); // push a copy
        d.setDate(d.getDate() + 1);
      }
    });

    allDays.map((date) => {
      let start = dayRange.startTime(date);
      let end = dayRange.endTime(date);
      dateRanges.push([dayRange.formatDate(start), dayRange.formatDate(end)]);
    });

    return [dateRanges, allDays];
  }

  allDatesInRange(start, end) {
    // ensure we get a proper Date object; this.day[0] like "2024-12-31T11"
    let currDate = typeof start === "string" ? new Date(start.replace(/(T\d{2})$/, "$1:00:00.000Z")) : new Date(start);
    let finalDay = typeof end === "string" ? new Date(end.replace(/(T\d{2})$/, "$1:00:00.000Z")) : new Date(end);

    let dates = [];
    let allDates = [];
    // get the day ranges for every day in the year
    while (currDate <= finalDay) {
      // does this need to be equal??
      // dates.push(new Date(currDate)); // clone!
      let start = dayRange.startTime(currDate);
      let end = dayRange.endTime(currDate);
      allDates.push(start);
      dates.push([dayRange.formatDate(start), dayRange.formatDate(end)]);

      currDate = dayRange.editDay(1, currDate); // must return a new Date
    }

    return [dates, allDates];
  }

  

  getRangeDates(startDate, endDate) {
    // used to get the labels for the range of days
    // and all the dates within the range
    const range = [];
    const checkingDates = [];

    // get the start date and the end date - the range
    const localeStart = startDate.toLocaleString();
    const localeEnd = endDate.toLocaleString();

    // get all the parts of the date to create new correct date objects
    // start of the first day and the end of the last day
    let startDay = localeStart.split("T")[0];
    let endDay = localeEnd.split("T")[0];
    let startMonth = parseInt(startDay.split("-")[1]) - 1;
    let endMonth = parseInt(endDay.split("-")[1]) - 1;
    let startYear = parseInt(startDay.split("-")[0]);
    let endYear = parseInt(endDay.split("-")[0]);
    let startHour = startDate.substring(11, 13);
    let endHour = endDate.substring(11, 13);

    // put these into new dat objects
    let start = new Date(startYear, startMonth, parseInt(startDay.split("-")[2]), startHour);
    let end = new Date(endYear, endMonth, parseInt(endDay.split("-")[2]), endHour);

    // loop through all the days
    for (let d = start; dayRange.startTime(d) < dayRange.startTime(end); d = dayRange.editDay(1, d)) {
      // put the date as a number into the range
      range.push(d.getDate());

      // put the whole object into another array
      checkingDates.push(d);
    }

    // return an array of both the dates ranges
    return [range, checkingDates];
  }
}

const reports = new Reports();
export { reports };
